import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, CircularProgress, FormControlLabel, Checkbox } from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline';
import { Alert } from '@material-ui/lab';

const formatNumber = (val) => {
    const num = parseFloat(val) || 0;
    return num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

class NewSimulPrepaid extends Component {
    state = {
        amount: '',
        nbMensualites: 1,
        raccordementPaye: false,
        result: null,
        error: null,
        loading: false,
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        const regex = /^[0-9.\b]+$/;
        if (value === '' || regex.test(value)) {
            this.setState({ [name]: value });
        }
    }

    simulate = async () => {
        const { amount, nbMensualites, raccordementPaye } = this.state;
        const { FixCost, ConnexionCost, DayDeposit, period } = this.props;

        if (!amount || parseFloat(amount) <= 0) {
            this.setState({ error: 'Veuillez saisir un montant', result: null });
            return;
        }

        const priceStepList = (period || []).map(p => ({
            NbKwh: parseFloat(p.days) || 0,
            Price: parseFloat(p.price) || 0,
        })).filter(p => p.Price > 0);

        const body = {
            Amount: parseFloat(amount),
            Deposit: raccordementPaye ? 0 : (parseFloat(ConnexionCost) || 0),
            InitialKWh: raccordementPaye ? 0 : (parseInt(DayDeposit) || 0),
            Fixcost: parseFloat(FixCost) || 0,
            PriceStepList: priceStepList,
            TotalAlreadyPaid: raccordementPaye ? 1 : 0,
            MonthDue: parseInt(nbMensualites) || 0,
        };

        this.setState({ loading: true, error: null, result: null });

        try {
            const response = await fetch('/subscription/simulate-prepaid', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify(body),
            });
            const data = await response.json();

            if (data.error) {
                this.setState({ error: data.error, result: data.result || null, loading: false });
            } else {
                this.setState({ result: data.result, error: null, loading: false });
            }
        } catch (err) {
            this.setState({ error: 'Erreur de connexion au serveur', loading: false });
        }
    }

    render() {
        const { FixCost, ConnexionCost, DayDeposit, period, originalPriceStep } = this.props;
        const { amount, nbMensualites, raccordementPaye, result, error, loading } = this.state;

        return (
            <PopUp
                title="Simulation Paiement Prépayé"
                submitAction={this.simulate}
                submitTitle="Simuler"
                close={this.props.close}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                                            <strong>Paramètres de l'abonnement</strong>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Raccordement</TableCell>
                                        <TableCell>{formatNumber(ConnexionCost)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>kWh offerts</TableCell>
                                        <TableCell>{DayDeposit || 0} kWh</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Partie fixe mensuelle</TableCell>
                                        <TableCell>{formatNumber(FixCost)}</TableCell>
                                    </TableRow>
                                    {period && period.filter(p => p.price).map((p, idx, arr) => {
                                        let prevSeuil = idx === 0 ? 0 : parseFloat(arr[idx - 1].days) || 0;
                                        let seuil = parseFloat(p.days) || 0;
                                        let label = seuil > 0 ? `${prevSeuil} → ${seuil} kWh` : `${prevSeuil}+ kWh`;
                                        return (
                                            <TableRow key={idx}>
                                                <TableCell>{label}</TableCell>
                                                <TableCell>
                                                    {formatNumber(p.price)} / kWh
                                                    {originalPriceStep && <span style={{opacity: 0.6}}> ({formatNumber(originalPriceStep.price)} pour {originalPriceStep.kwh} kWh)</span>}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={raccordementPaye}
                                    onChange={(e) => this.setState({ raccordementPaye: e.target.checked })}
                                    color="primary"
                                />
                            }
                            label="Raccordement déjà payé"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <InputText
                            type="number"
                            label="Montant payé"
                            value={amount}
                            onChange={this.handleChange}
                            name="amount"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            type="number"
                            label="Nombre de mensualités"
                            value={nbMensualites}
                            onChange={this.handleChange}
                            name="nbMensualites"
                        />
                    </Grid>

                    {loading &&
                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                            <CircularProgress size={24} />
                        </Grid>
                    }

                    {error &&
                        <Grid item xs={12}>
                            <Alert severity="error">{error}</Alert>
                        </Grid>
                    }

                    {result &&
                        <Grid item xs={12}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                                                <strong>Résultat</strong>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>kWh crédités</TableCell>
                                            <TableCell><strong>{result.KWhCredited} kWh</strong>
                                                {result.KWhOfferts > 0 && result.KWhAchetes > 0 &&
                                                    <span> ({result.KWhOfferts} offerts + {result.KWhAchetes} achetés)</span>
                                                }
                                                {result.KWhOfferts > 0 && result.KWhAchetes === 0 &&
                                                    <span> (offerts)</span>
                                                }
                                                {result.KWhOfferts === 0 && result.KWhAchetes > 0 &&
                                                    <span> (achetés)</span>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        {result.MonthsPaid > 0 &&
                                        <TableRow>
                                            <TableCell>Mensualités payées</TableCell>
                                            <TableCell>{result.MonthsPaid} mois ({formatNumber(result.MonthsPaid * (parseFloat(FixCost) || 0))})</TableCell>
                                        </TableRow>
                                        }
                                        {result.MonthsUnpaid > 0 &&
                                        <TableRow>
                                            <TableCell style={{color: '#d32f2f'}}>Mensualités impayées</TableCell>
                                            <TableCell style={{color: '#d32f2f'}}><strong>{result.MonthsUnpaid} mois</strong> — il manque {formatNumber(result.AmountMissing)}</TableCell>
                                        </TableRow>
                                        }
                                        <TableRow>
                                            <TableCell>Reste non utilisé</TableCell>
                                            <TableCell>{formatNumber(result.AmountLeftover)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    }
                </Grid>
            </PopUp>
        );
    }
}

export default NewSimulPrepaid;
